import { Injectable } from "@angular/core";
import { MfaActionsService, MfaErrorCodeType, MfaPhoneStatus, MfaService, VerifyMfaCodeData, isAuthThrottleError } from "common";
import { PasswordChangeService } from "../../user/password-change/service/password-change.service";
import { MfaTokenPayload } from "../model/mfa.model";
import { PasswordChangeRequest, PasswordChangeResponse } from "../../user/password-change/model/password-change.model";


@Injectable({
  providedIn: 'root'
})
export class MfaChangePasswordService {
  constructor(
    private mfaActions: MfaActionsService,
    private passwordChangeService: PasswordChangeService,
    private mfaService: MfaService
  ) { }

  verify(data: VerifyMfaCodeData): void {
    const token: MfaTokenPayload = {
      mfaCode: data.mfaCode,
      mfaToken: data.mfaData.mfaToken
    };
    const req: PasswordChangeRequest = {
      newPassword: data.mfaData.contextData?.newPassword,
      oldPassword: data.mfaData.contextData?.oldPassword,
      ssoToken: data.mfaData.contextData?.ssoToken,
      returnUrl: data.mfaData.contextData?.returnUrl
    };

    if (data.mfaData.phoneStatus === MfaPhoneStatus.Verified) {
      this.passwordChangeService.changePassword(req, token)
        .subscribe((data: PasswordChangeResponse) =>
          this.handleMfaChangePasswordResponse(data)
        )
    }
  }

  private handleMfaChangePasswordResponse(data: PasswordChangeResponse): void {
    if (!data?.hasError) {
      this.mfaService.handleMfaSuccess();
      return;
    }

    if (data?.errorCode === MfaErrorCodeType.InvalidMfaCode) {
      this.mfaActions.invalidCode();
      return;
    }

    if (isAuthThrottleError(data?.errorCode)) {
      return;
    }

    this.mfaService.handleMfaError();
  }
}
